import script from "./ArticleCreateField.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleCreateField.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleCreateField.vue?vue&type=style&index=0&id=37dcf856&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37dcf856"]])

export default __exports__